(function ($, njm) {
    'use strict';

    njm.views.searchResults = Backbone.View.extend({

        events: {
            'click .filter-selected': 'open',
            'click .filter-list a': 'selectCategory',
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$category = this.$('.filter-list a');
            this.$selectedCategory = this.$category.filter('.active');
            this.$selectedLabel = this.$('.filter-selected');
			this.$dropdown = this.$('.filter-list');
			
			var params = new URLSearchParams(window.location.search),
				query = params.get('q'),
				searchInput = this.$('#searchInput'),
				$this = this;

            if (this.$selectedCategory.length > 0) {
                this.$selectedLabel.html(this.$selectedCategory.html());
            }
            
            $("#searchInput").on({
                keyup: function () {
                    $this.getSuggestions();
                },

                click: function () {
                    $this.getSuggestions();
                },

                focus: function () {
                    $this.getSuggestions();
                }

            });

            $('body').click(function (event) {

                if ( $(event.target).closest('#inSearchResult').length != 1 && $(event.target).closest('#searchInput').length != 1 && $(event.target).closest('.search-box label[for=searchInput]').length != 1 ) {
                    $this.slideUp();
                }
				
				if ( $(event.target).closest('.search-filters .filter-select').length < 1) {
					$this.$dropdown.slideUp();
				}
            });

            this.initialiseLiComponents();
			
			if (query != null) {
				searchInput.val(query);
			}
        },

        /**
         * Select filter
         */
        open: function () {
            this.$dropdown.slideToggle();
        },
        selectCategory: function (e) {
            e.preventDefault();
            var element = $(e.currentTarget);
            var form = element.closest("form");
            //form.action = element[0].href;
           // form.find('input[id=searchInputCategory]').val(element[0].text);
            form.find('input[id=searchInputCategory]').val(element[0].getAttribute('data-val'));
            form.find('input[id=searchInput]').val($('#searchInput').attr('data-val'));
            form.find('input[id=checkRequired]').val('true');
            form[0].submit();
        },
        getSuggestions: function () {

            var $this = this,
                search = $('#searchInput').val().toLowerCase();
			
			search = jQuery.trim(search);

            if (search != "" && search.length > 2) {
                $.ajax({
                    url: '/api/search/suggest/GetSuggestions',
                    type: 'get',
                    data: { term: search },
                    dataType: 'json',
                    success: function (response) {

                        var len = response.length;
                        $("#inSearchResult").empty();
                        for (var i = 0; i < len; i++) {
                            var name = response[i].toLowerCase();
                            $("#inSearchResult").append("<li value='" + i + "'><a href='#'>" + name.replace(search, '<strong>' + search + '</strong>') + "</a></li>");
                        }
                        //binding click event to li
                        if (len > 0) {
                            $this.initialiseLiComponents();
                            $('#inSearchResult').show();
                        }
                    },
                    error: function (response) {

                    }
                });
            }
            else {
                $("#inSearchResult").empty();
            }
        },

        slideUp: function () {
            $('#inSearchResult').slideUp();
        },

        initialiseLiComponents: function () {
            var $this = this;
            var component = $('#inSearchResult');
            var focusableEls = component.find('li a');
            var lastFocusableEl = $(focusableEls[focusableEls.length - 1]);

            component.find('li a').on({
                click: function (event) {
                    $this.setText(event);
                }
            });

            lastFocusableEl.keydown(function (event) {
                $this.lastFocusableElTab(event);
            });
        },

        setText: function (event) {
            event.preventDefault();
            var response = $(event.target).closest('a').text();
            $("#searchInput").val(response);
            $("#searchResultForm").submit();
            this.slideUp();
        },

        lastFocusableElTab: function (event) {

            var key = event.which;

            if (key === 9) { //tab
                if (!event.shiftKey) {
                    this.slideUp();
                }
            }
        }
      

    });
})(jQuery, njm);
